'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('@emotion/styled');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Logo = styled__default["default"].a(({ grid }) => {
  const {
    logoGridRow,
    logoGridColumn,
    logoJustifySelf,
    logoSpacing,
    logoWidth
  } = grid;
  return `
    display: inline-flex;
    grid-row: ${logoGridRow};
    grid-column: ${logoGridColumn};
    align-self: center;
    justify-self: ${logoJustifySelf};
    margin: ${logoSpacing};
    width: ${logoWidth}px;
  `;
});
const LogoImg = styled__default["default"].img(({ grid }) => {
  const { logoImageObjectPosition } = grid;
  return `
    width: 100%;
    height: 100%;
  
    vertical-align: middle;
    object-fit: contain;
    object-position: ${logoImageObjectPosition};
  `;
});

exports.Logo = Logo;
exports.LogoImg = LogoImg;
